import { render, staticRenderFns } from "./asset_reclass.vue?vue&type=template&id=33249945"
import script from "./asset_reclass.vue?vue&type=script&lang=js"
export * from "./asset_reclass.vue?vue&type=script&lang=js"
import style0 from "./asset_reclass.vue?vue&type=style&index=0&id=33249945&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports